import * as React from 'react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';

export function TabSkeleton({ count = 4 }: { count?: number }) {
	return (
		<Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
			{Array.from({ length: count }).map((_, i) => (
				<Skeleton key={i} variant="rectangular" width={100} height={36} />
			))}
		</Box>
	);
}

export default function LoadingSkeleton() {
    return (
        <Box>
            <Card sx={{ px: 4, py: 2 }}>
                <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1 }}>
                        <Skeleton variant="text" width={120} />
                    </Typography>
                    <Grid container direction="column" spacing={1}>
                        <Grid item>
                            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                                <Skeleton variant="rectangular" width={56} height={56} />
                                <Box sx={{ flex: 1 }}>
                                    <Skeleton variant="text" width="60%" />
                                    <Skeleton variant="text" width="40%" />
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Card>
        </Box>
    );
}
